import { render } from "./CustomFileThumbnail.vue?vue&type=template&id=fd3275a6"
import script from "./CustomFileThumbnail.vue?vue&type=script&lang=js"
export * from "./CustomFileThumbnail.vue?vue&type=script&lang=js"
script.render = render

export default script